import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

jQuery(document).ready(function($) {
  let messageForUser = $("div[data-drupal-messages]");
  if(messageForUser.find('.messages')) {
    setTimeout(() => {
      $("div[data-drupal-messages]").each(() => {
        $("div[data-drupal-messages]").find('.messages').slideUp(2000);
      });
    }, 9000);
  }

  setTimeout(() => {
    $("#loader-page").fadeOut(100);
  }, 400);
});
